// Topbar countdown for announcement bar
// Her gün belirlenen saate (varsayılan 23:59) sayar, gece otomatik yenilenir.
// Anasayfadaki home-countdown ile aynı mantık → iki sayaç senkron.
(function(){
  function initOne(el) {
    var H = parseInt(el.getAttribute('data-deadline-hour') || '23', 10);
    var M = parseInt(el.getAttribute('data-deadline-min') || '59', 10);
    if (isNaN(H)) H = 23;
    if (isNaN(M)) M = 59;

    function deadlineFrom(now) {
      var d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), H, M, 0, 0);
      if (d.getTime() <= now.getTime()) { d.setDate(d.getDate() + 1); }
      return d;
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function update() {
      var now = new Date();
      var left = deadlineFrom(now).getTime() - now.getTime();
      if (left < 0) left = 0;
      var h = Math.floor(left / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var s = Math.floor((left % 60000) / 1000);

      var hEl = el.querySelector('.topbar-countdown__h');
      var mEl = el.querySelector('.topbar-countdown__m');
      var sEl = el.querySelector('.topbar-countdown__s');
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }

    update();
    setInterval(update, 1000);
  }

  function init() {
    var nodes = document.querySelectorAll('.topbar-countdown__display');
    if (!nodes.length) return;
    nodes.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
